import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "sprout-ui-primitives";
import styled from "styled-components";
import { colors, hexes } from "./colors";
import TopicPageEditorDividerColor from "./TopicPageEditorDividerColor";
const TopicPageEditorDividerColorPickerWrapper = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fill, 24px);
  grid-gap: 4px;
`;
const TopicPageEditorDividerColorPicker = (props)=>{
    const { onChange , value  } = props;
    return /*#__PURE__*/ _jsx(TopicPageEditorDividerColorPickerWrapper, {
        pt: "8px",
        pb: "16px",
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: "grey.300",
        children: colors.map((color)=>/*#__PURE__*/ _jsx(TopicPageEditorDividerColor, {
                value: color,
                colorHex: hexes[color],
                checked: color === value,
                onChange: onChange
            }, color))
    });
};
export default TopicPageEditorDividerColorPicker;
